import { Account } from "../../business-objects/account/account.model";
import { SyncUpItem } from "../../business-objects/sync-up-item/sync-up-item.model";

export interface ISyncManagerButtonModelArgs {
    account: Account;
    syncUpItems: Array<SyncUpItem>;
}

export interface ISyncManagerButtonModelGetInstanceArgs {
    account: Account;
    syncUpItems: Array<SyncUpItem>;
}

export class SyncManagerButtonModel {
    protected _account: Account;
    protected _syncUpItems: Array<SyncUpItem>;

    static getInstance(args: ISyncManagerButtonModelGetInstanceArgs): SyncManagerButtonModel {
        return new SyncManagerButtonModel({
            account: args.account,
            syncUpItems: args.syncUpItems
        });
    }

    constructor(args?: ISyncManagerButtonModelArgs) {
        Object.keys(args).forEach(key => {
            this[`_${key}`] = args[key];
        });
    }

    get account(): Account {
        return this._account;
    }

    get accountId(): string {
        return this._account && this._account.id;
    }

    get errors(): number {
        return (this._syncUpItems || []).filter(item => !item.ok).length;
    }

    get show(): boolean {
        return this.account && this.errors > 0;
    }
}



// WEBPACK FOOTER //
// ./src/vas/modules-other/sync-manager-button/sync-manager-button.model.ts